import { useEffect, useCallback, useMemo } from 'react';
import { useAppDispatch } from './redux/hooks';
import { finishLoading, setDisconnected, verifyAppVersion } from './redux/reducers/appLoaderReducer';
import { StartPage } from './components/initialPage/initialPage';
import { CustomerClient, ServiceClient } from './helpers/client';
import './helpers/extensions';
import { useRouteNavigator } from './routes/useRouteNavigator';

export function Init() {
  const dispatch = useAppDispatch();
  const routeNavigator = useRouteNavigator();
  const customerClient = useMemo(() => new CustomerClient(), []);
  const servicesClient = useMemo(() => new ServiceClient(), []);

  if (window.cordova) {
    document.addEventListener('offline', function () {
      dispatch(setDisconnected(true));
    });
    document.addEventListener('online', function () {
      dispatch(setDisconnected(false));
    });
  } else {
    window.addEventListener('offline', function () {
      dispatch(setDisconnected(true));
    });
    window.addEventListener('online', function () {
      dispatch(setDisconnected(false));
    });
  }

  if (window.MobileAccessibility) {
    window.MobileAccessibility.usePreferredTextZoom(false);
  }

  const testAuthorization = useCallback(() => {
    customerClient
      .getInfo()
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
  }, [customerClient]);

  const testConnectivity = useCallback(() => {
    Promise.all([dispatch(verifyAppVersion()), servicesClient.getCategories()])
      .then(() => {
        setTimeout(function () {
          routeNavigator.goHome(true);
          dispatch(finishLoading());
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dispatch, servicesClient, routeNavigator]);

  const initData = useCallback(() => {
    testConnectivity();
    testAuthorization();
  }, [testConnectivity, testAuthorization]);

  useEffect(() => {
    initData();
  }, [initData]);

  return <StartPage />;
}
